/** Reports: every report page this login may open, grouped by module (2026-10-15). */
import { createFileRoute } from "@tanstack/react-router";
import { ReportsHubPage } from "@/features/reports/reports-hub-page";

export const Route = createFileRoute("/_app/reports/")({
  component: ReportsHubPage,
});
